import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { PasswordField } from "@/components/AuthPanel";
import { BigButton } from "@/components/Layout";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const ChangePasswordForm = ({ onDone }) => {
  const { user, refreshUser, t } = useApp();
  const needCurrent = user.has_password && !user.can_skip_current_password;
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (f.next.length < 6) return toast.error(t("Password should be at least 6 characters."));
    if (f.next !== f.confirm) return toast.error(t("The two passwords don't match."));
    setBusy(true);
    try {
      await api.put("/auth/password", { current_password: f.current, new_password: f.next });
      toast.success(t("Password saved"));
      setF({ current: "", next: "", confirm: "" });
      await refreshUser();
      onDone?.();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-3" data-testid="change-password-form">
      {needCurrent && <PasswordField placeholder={t("Current password")} value={f.current} onChange={(v) => setF({ ...f, current: v })} autoComplete="current-password" testid="current-password-input" />}
      <PasswordField placeholder={t("New password (at least 6 characters)")} value={f.next} onChange={(v) => setF({ ...f, next: v })} autoComplete="new-password" testid="new-password-input" />
      <PasswordField placeholder={t("Type the new password again")} value={f.confirm} onChange={(v) => setF({ ...f, confirm: v })} autoComplete="new-password" testid="confirm-password-input" />
      <BigButton onClick={save} disabled={busy} data-testid="save-password-btn">{busy ? t("Saving…") : t("Save password")}</BigButton>
    </div>
  );
};

export const ForcePasswordDialog = () => {
  const { user, t } = useApp();
  if (!user?.must_change_password) return null;
  return (
    <Dialog open>
      <DialogContent className="max-w-[92vw] rounded-3xl sm:max-w-sm [&>button]:hidden" data-testid="force-password-dialog">
        <DialogHeader className="text-left">
          <DialogTitle className="font-display text-xl text-[#0D3B2B]">{t("Set your own password")}</DialogTitle>
          <DialogDescription>{t("You logged in with a temporary password. Please choose a new one to keep your account safe.")}</DialogDescription>
        </DialogHeader>
        <ChangePasswordForm />
      </DialogContent>
    </Dialog>
  );
};
